<script>
	import { Col, Row, Button } from "@sveltestrap/sveltestrap";
	import { Splide, SplideSlide } from "@splidejs/svelte-splide";
	import { api } from "../../../../../services/helpers";
	import client from "../../../../../services/client";
	import { convert } from "../../../../../services/helpers";
	import { splitImageUrl } from "../../../../../utils/misc";
	import {
		loading,
		loadSpinner,
		DynamicComponent,
		imageLightbox,
	} from "../../../../../store/store";
	export let options = [];
	export let issues;
	export let img_url = [];
	import { form, field } from "svelte-forms";
	//lightbox with image
	import Lightbox from "../../../../../components/Lightbox/Lightbox.svelte";

	import { required } from "svelte-forms/validators";

	const handleReject = async (issueId) => {
		try {
			loading.set(true);
			const res = await client("/v0/Issue/reject", {
				method: "POST",
				version: "Tasking",
				data: {
					issueId,
					rejectReason: "Irrelevant",
				},
			});
			window.location.reload();
		} catch (err) {
			console.log(err.response);
		}
	};

	const handleClick = () => {
		DynamicComponent.set(3);
	};

	const impact = field("impact", "", [required()]);
	const quotation = field("quotation", "", [required()]);
	const myForm = form(impact, quotation);
	let load = false;
	let isCreate = false;

	const handleApprove = async () => {
		try {
			load = true;
			loadSpinner.set(true);
			const formData = new FormData();
			formData.append("issueId", issues.issueId);
			formData.append("Impact", $impact.value);
			formData.append("quotation", $quotation.value);
			formData.append("reportSection", issues.reportSection);
			formData.append(
				"sourceTable",
				issues.originType === 1 ? "CMS" : "FMS"
			);
			formData.append("vehicleId", issues.vehicleId);
			for (let i = 0; i < issues.imageUrls.length; i++) {
				formData.append(
					"ImageUrls",
					splitImageUrl(issues.imageUrls[i])
				);
			}
			formData.append("description", issues.description);
			formData.append("tripStatus", issues.tripStatus);
			formData.append("carSection", issues.carSection);
			formData.append("DamageType", issues.damageType);
			formData.append("reportedIssueId", issues.issueId);
			formData.append("reportedAt", issues.dateReported);

			const createNewIssue = await api(
				"/v0/Issue/v2/CreateIssue",
				"Tasking",
				"POST",
				formData,
				{},
				localStorage.getItem("token"),
				"multipart"
			);

			if (createNewIssue.data.error_code == 201) {
				const approveIssue = await client("/v0/Issue/Approve", {
					method: "POST",
					version: "Tasking",
					data: {
						issueId: issues.issueId,
					},
				});
				if (approveIssue.data.error_code === 0) {
					load = false;
					loadSpinner.set(false);
					window.location.reload();
				}
			}
		} catch (err) {
			load = false;
			loadSpinner.set(false);
		}
	};

	let modalOpen = false;

	let imageShowingIndex = 0;

	const handleImgClick = (i) => {
		imageLightbox.set(img_url);
		imageShowingIndex = Number(i);
		modalOpen = true;
	};
</script>

{#if modalOpen}
	<Lightbox on:click={() => (modalOpen = false)} {imageShowingIndex} />
{/if}

<Col xs={12}>
	<Splide {options} aria-label="My Favorite Images">
		{#each img_url as slide, index}
			<SplideSlide active={1}>
				<!-- svelte-ignore a11y-click-events-have-key-events -->
				<img
					src={slide}
					alt="alt"
					style="width: 100%; height:100%; object-fit: scale-down; "
					class="link"
					on:click={() => handleImgClick(index)}
				/>
			</SplideSlide>
		{/each}
	</Splide>
</Col>
<Col xs={12} class="my-2">
	<Col md={6} class="mt-4">
		<Row class="my-3">
			<Col><span>Date Reported</span></Col>
			<Col>
				<b>
					{convert(issues.dateReported)}
				</b>
			</Col>
		</Row>
		<Row class="my-3">
			<Col><span>Damage Type</span></Col>
			<Col>
				<b> {issues.damageType} </b>
			</Col>
		</Row>
		<Row class="my-3">
			<Col><span>Car Section</span></Col>
			<Col>
				<b> {issues.carSection} </b>
			</Col>
		</Row>
		<Row class="my-3">
			<Col>
				<span
					class={$myForm.hasError("impact.required")
						? "error-text"
						: ""}>Damage Impact*</span
				>
			</Col>
			<Col>
				<div class="form-check">
					<input
						class="form-check-input"
						type="radio"
						name="flexRadioDefault"
						id="flexRadioDefault1"
						value="0"
						bind:group={$impact.value}
					/>
					<label
						class={$myForm.hasError("impact.required")
							? "error-text"
							: "form-check-label"}
						for="flexRadioDefault1"
					>
						<b>VQP 0</b>
					</label>
				</div>
				<div class="form-check">
					<input
						class="form-check-input"
						type="radio"
						name="flexRadioDefault"
						id="flexRadioDefault2"
						value="1"
						bind:group={$impact.value}
					/>
					<label
						class={$myForm.hasError("impact.required")
							? "error-text"
							: "form-check-label"}
						for="flexRadioDefault2"
					>
						<b>VQP 1</b>
					</label>
				</div>
				<div class="form-check">
					<input
						class="form-check-input"
						type="radio"
						name="flexRadioDefault"
						id="flexRadioDefault3"
						value="2"
						bind:group={$impact.value}
					/>
					<label
						class={$myForm.hasError("impact.required")
							? "error-text"
							: "form-check-label"}
						for="flexRadioDefault3"
					>
						<b>VQP 2</b>
					</label>
				</div>
			</Col>
		</Row>
		<Row class="mt-3">
			<Col>
				<span>Quotation</span>
			</Col>
			<Col>
				<div class="form-check">
					<input
						class="form-check-input"
						type="radio"
						name="quotation"
						id="quotation1"
						value="Pending"
						on:change={() => (isCreate = false)}
						bind:group={$quotation.value}
					/>
					<label for="quotation1">
						<b>Pending</b>
					</label>
				</div>
				<div class="form-check">
					<input
						class="form-check-input"
						type="radio"
						name="quotation"
						id="quotation2"
						value={true}
						on:change={quotation.reset}
						bind:group={isCreate}
					/>
					<label for="quotation2">
						<b>Create</b>
					</label>
				</div>
			</Col>
		</Row>
	</Col>
	{#if isCreate}
		<Col xxl={12}>
			<Row>
				<Col md={3} sm={6}><span /></Col>

				<Col md={8} sm={6} class="ms-2 mt-1">
					<textarea
						type="text"
						aria-label="Quotation"
						bind:value={$quotation.value}
						style="height: 150px;"
						placeholder="Start typing your quotation"
						class="form-control getgo input"
					/>
				</Col>
			</Row>
		</Col>
	{/if}
</Col>
<Col xs={12}>
	{#if $myForm.hasError("impact.required")}
		<Row>
			<div class="d-flex justify-content-end pe-5">
				<p class="error-text d-flex justify-content-center pe-5">
					Please select impact!
				</p>
			</div>
		</Row>
	{/if}

	{#if $DynamicComponent !== 2}
		<Row class="mb-2">
			{#if load}
				<div class="d-flex justify-content-end pe-5">
					<Button
						class="customButton primary-blue"
						type="button"
						disabled
					>
						<output
							class="spinner-grow spinner-grow-sm"
							aria-hidden="true"
						/>
						Loading...
					</Button>
				</div>
			{:else}
				<span class="d-flex justify-content-end pe-5">
					<Button
						class="customButton primary-blue "
						on:click={myForm.validate}
						on:click={() => handleApprove(issues.issueId)}
					>
						Approve
					</Button>
				</span>
			{/if}
		</Row>
		<Row class="my-2">
			<span class="d-flex justify-content-end pe-5">
				<Button
					class="customButton primary-white "
					on:click={() => handleReject(issues.issueId)}>Reject</Button
				>
			</span>
		</Row>
		<Row class="my-2 mb-4">
			<span class="d-flex justify-content-end pe-5">
				<Button
					class="customButton primary-white "
					on:click={() => handleClick()}>Split</Button
				>
			</span>
		</Row>
	{/if}
</Col>
